import React from "react";

function TrainBooking() {
  return <div>TrainBooking</div>;
}

export default TrainBooking;
